import { Maybe } from 'ballerina-core'
import i18next from 'i18next'
import { List, Map, fromJS } from 'immutable'
import { FiltersMap, FiltersResponse } from './filters.state'
import { TeaserKind } from '../teasers/teasers.state'

export const getFilters = async (itemKind: TeaserKind): Promise<Maybe<FiltersMap>> => {
  const overviewKind = itemKind.replace('-overview', '')

  const res = await fetch(`/api/cms/filter/${overviewKind}?language=${i18next.language}`)

  try {
    const json: FiltersResponse = await res.json()
    const finalRes: FiltersMap = fromJS(json, (key, value) => {
      if (key === "") {
        return Map(value)
      }
      if (Array.isArray(value.toJS())) return List(value)

      return value.toObject()
    })

    return finalRes
  } catch (e) {
    return undefined
  }
}
